(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["kv-home-tabbed-products"] && !Shopify.designMode) return;
  try {
    
  const activateKverseTab = (tab, moveFocus = false) => {
    const section = tab.closest('.kv-home-tabs');
    section.querySelectorAll('[data-kv-tab]').forEach((item) => {
      const selected = item === tab;
      item.setAttribute('aria-selected', selected ? 'true' : 'false');
      item.tabIndex = selected ? 0 : -1;
    });
    section.querySelectorAll('[data-kv-panel]').forEach((panel) => {
      panel.hidden = panel.id !== tab.getAttribute('aria-controls');
    });
    if (moveFocus) tab.focus();
  };

  document.addEventListener('click', (event) => {
    const tab = event.target.closest('[data-kv-tab]');
    if (!tab) return;
    activateKverseTab(tab);
  });

  document.addEventListener('keydown', (event) => {
    const tab = event.target.closest('[data-kv-tab]');
    if (!tab || !['ArrowLeft', 'ArrowRight', 'Home', 'End'].includes(event.key)) return;
    const tabs = Array.from(tab.closest('.kv-home-tabs').querySelectorAll('[data-kv-tab]'));
    const currentIndex = tabs.indexOf(tab);
    let nextIndex = currentIndex;
    if (event.key === 'Home') nextIndex = 0;
    if (event.key === 'End') nextIndex = tabs.length - 1;
    if (event.key === 'ArrowLeft') nextIndex = (currentIndex - 1 + tabs.length) % tabs.length;
    if (event.key === 'ArrowRight') nextIndex = (currentIndex + 1) % tabs.length;
    event.preventDefault();
    activateKverseTab(tabs[nextIndex], true);
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
